import React from "react";
import PaymentOptions from "../components/payment_options";

const Donation = () => {
  return (
    <>
      <main id="main">
        <div className="breadcrumbs" data-aos="fade-in">
          <div className="container">
            <h2>Donation</h2>
            <p>
              Your small contribution can make a huge impact. Every donation
              counts.
            </p>
          </div>
        </div>
        <PaymentOptions />
        <br></br>
      </main>
    </>
  );
};

export default Donation;
